export default {
  header: 'Scegli il menu',
  open_now: 'Aperto ora',
};
